export default __webpack_public_path__ + "media/zurb/img/lab/playground/playground-codepen-9a2790df31bf7452907b06502c179d97.png";